// const Span = { index: 1, count: 1 }
export function compareSpans(x, y) {
  return x.index - y.index;
}

export function sortSpans(spansArray) {
  return spansArray.sort((a, b) => compareSpans(a, b));
}

function spanHelper(x, y) {
  const [a, b] = sortSpans([x, y]);
  return {
    spans: [a, b],
    aEnd: a.index + a.count - 1,
    bEnd: b.index + b.count - 1
  }
}

export function intersectSpans(x, y) {
  const { spans: [a, b], aEnd, bEnd } = spanHelper(x, y);

  if (aEnd < b.index) {
    return null;
  }

  if (aEnd >= bEnd) {
    return b;
  }

  return { index: b.index, count: aEnd - b.index + 1 };
}

export function mergeSpans(x, y) {
  const { spans: [a, b], aEnd, bEnd } = spanHelper(x, y);

  if (aEnd < b.index - 1) {
    return [a, b];
  }

  if (aEnd >= bEnd) {
    return [a];
  }

  return [{ index: a.index, count: bEnd - a.index + 1 }];
}

export function mergeSpanArray(spans) {
  return sortSpans(spans).reduce((out, x) => {
    if (!out.length) { out.push(x); return out; }
    const lastIndex = out.length - 1;
    const [first, second] = mergeSpans(out[lastIndex], x);
    out[lastIndex] = first;
    if (second) { out.push(second); }
    return out;
  }, []);
}

export function intersectSpanWithSpans(target, spans) {
  return mergeSpanArray(spans.reduce((out, x) => {
    const i = intersectSpans(target, x);
    if (i) { out.push(i); }
    return out;
  }, []));
}

export function rangeToRowSpan(range, isRelative = false) {
  return { index: isRelative ? 0 : range.rowIndex, count: range.rowCount };
}

export function rangeToColumnSpan(range, isRelative = false) {
  return { index: isRelative ? 0 : range.columnIndex, count: range.columnCount };
}

export function getIntersectionRowSpans(targetRange, ranges) {
  const targetColumnSpan = rangeToColumnSpan(targetRange);
  const targetRowSpan = rangeToRowSpan(targetRange);

  const filteredByColumn = ranges
    .map(x => ({ ...rangeToColumnSpan(x), rowIndex: x.rowIndex, rowCount: x.rowCount }))
    .filter(x => !!intersectSpans(targetColumnSpan, x))
    .map(x => rangeToRowSpan(x));

  return intersectSpanWithSpans(targetRowSpan, filteredByColumn);
}

export function foldIndexesToSpans(indexes) {
  const spans = [];

  let previousIndex = null;

  const startSpan = (index) => {
    spans.push({ index, count: null });
  }

  const endSpan = () => {
    if (spans.length) {
      const r = spans[spans.length - 1];
      r.count = previousIndex - r.index + 1;
    }
  }

  for (const index of indexes) {
    if (null === previousIndex) {
      previousIndex = index;
      startSpan(index);
    }

    const indexDelta = index - previousIndex;
    if (indexDelta > 1) {
      endSpan();
      startSpan(index);
    }

    previousIndex = index;
  }

  endSpan();

  return spans;
}

export function foldCriteriasToSpans(criterias) {
  return foldIndexesToSpans(criterias.map((x, i) => !!x ? i : -1).filter(x => -1 !== x));
}


// TODO: Bring the code above to this class
